import { render, staticRenderFns } from "./ProjectsDialog.vue?vue&type=template&id=d0158590&scoped=true&"
import script from "./ProjectsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsDialog.vue?vue&type=style&index=0&id=d0158590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0158590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
